import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import {
  CreatePatientWorkflowApi,
  CreatePatientWorkflowFailureApi,
  CreatePatientWorkflowSuccessApi,
  DeletePatientWorkflowApi,
  DeletePatientWorkflowFailureApi,
  DeletePatientWorkflowSuccessApi,
  LoadPatientWorkflowApi,
  LoadPatientWorkflowFailureApi,
  LoadPatientWorkflowsApi,
  LoadPatientWorkflowsFailureApi,
  LoadPatientWorkflowsSuccessApi,
  LoadPatientWorkflowSuccessApi,
  PatientWorkflowApiActionTypes,
  UpdatePatientWorkflowApi,
  UpdatePatientWorkflowFailureApi,
  UpdatePatientWorkflowSuccessApi,
} from './patient-workflow-api.actions';
import { PatientWorkflowApiService } from './patient-workflow-api.service';

@Injectable()
export class PatientWorkflowApiEffects {
  loadPatientWorkflowsApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PatientWorkflowApiActionTypes.LoadPatientWorkflowsApi),
      switchMap(({ payload }: LoadPatientWorkflowsApi) =>
        this.srv.get(payload.params).pipe(
          map(
            (patientWorkflows) => new LoadPatientWorkflowsSuccessApi({ patientWorkflows })
          ),
          catchError((err) => of(new LoadPatientWorkflowsFailureApi(err)))
        )
      )
    )
  );

  loadOnePatientWorkflowsApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PatientWorkflowApiActionTypes.LoadPatientWorkflowApi),
      switchMap(({ payload: { id } }: LoadPatientWorkflowApi) =>
        this.srv.getOne(id).pipe(
          map(
            (patientWorkflow) => new LoadPatientWorkflowSuccessApi({ patientWorkflow })
          ),
          catchError(({ message }) =>
            of(new LoadPatientWorkflowFailureApi({ id, message }))
          )
        )
      )
    )
  );

  createPatientWorkflowApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PatientWorkflowApiActionTypes.CreatePatientWorkflowApi),
      mergeMap(({ payload }: CreatePatientWorkflowApi) =>
        this.srv.create(payload.patientWorkflow).pipe(
          map(
            (patientWorkflow) => new CreatePatientWorkflowSuccessApi({ patientWorkflow })
          ),
          catchError((error) => of(new CreatePatientWorkflowFailureApi(error)))
        )
      )
    )
  );

  updatePatientWorkflowApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PatientWorkflowApiActionTypes.UpdatePatientWorkflowApi),
      mergeMap(({ payload }: UpdatePatientWorkflowApi) =>
        this.srv.update(payload.patientWorkflow).pipe(
          map(
            (patientWorkflow) => new UpdatePatientWorkflowSuccessApi({ patientWorkflow })
          ),
          catchError((error) => of(new UpdatePatientWorkflowFailureApi(error)))
        )
      )
    )
  );

  deletePatientWorkflowApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PatientWorkflowApiActionTypes.DeletePatientWorkflowApi),
      mergeMap(({ payload }: DeletePatientWorkflowApi) =>
        this.srv.delete(payload.id).pipe(
          map(({ id }) => new DeletePatientWorkflowSuccessApi({ id: payload.id })),
          catchError((err) => of(new DeletePatientWorkflowFailureApi(err)))
        )
      )
    )
  );

  constructor(private actions$: Actions, private srv: PatientWorkflowApiService) {}
}
